import React, { useState } from "react";
import Modal from "react-modal";
import CommonButton from "../elments/CommonButton";

const QuestionPreview = ({ question, questionNumber }) => {
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  if (!question || !questionNumber) return null;

  const renderQuestionContent = () => {
    return (
      <div className="question-preview-content">
        <div className="preview-section">
          <label>Type:</label>
          <span className="type-badge">{question.type || "Not set"}</span>
        </div>

        <div className="preview-section">
          <label>Title:</label>
          <div
            className="preview-html-content"
            dangerouslySetInnerHTML={{ __html: question.Qtitle || "No title" }}
          />
        </div>

        {question.instructions && (
          <div className="preview-section">
            <label>Instructions:</label>
            <div
              className="preview-html-content"
              dangerouslySetInnerHTML={{ __html: question.instructions }}
            />
          </div>
        )}

        {question.logics && (
          <div className="preview-section">
            <label>Logic:</label>
            <span className="logic-text">{question.logics}</span>
          </div>
        )}

        {question.termLogic && (
          <div className="preview-section">
            <label>Termination Logic:</label>
            <span className="logic-text">{question.termLogic}</span>
          </div>
        )}

        {/* Table View for Rows and Columns */}
        {question.rows &&
          question.rows.length > 0 &&
          question.columns &&
          question.columns.length > 0 && (
            <div className="preview-section">
              <label>Question Matrix:</label>
              <div style={{ overflowX: "auto", marginTop: "12px" }}>
                <table
                  style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    border: "1px solid #e5e7eb",
                    fontSize: "14px",
                  }}
                >
                  <thead>
                    <tr style={{ backgroundColor: "#f9fafb" }}>
                      <th
                        style={{
                          border: "1px solid #e5e7eb",
                          padding: "10px",
                          textAlign: "left",
                          fontWeight: "600",
                          color: "#514137ff",
                          minWidth: "200px",
                        }}
                      >
                        Rows / Columns
                      </th>
                      {question.columns.map((col, index) => (
                        <th
                          key={index}
                          style={{
                            border: "1px solid #e5e7eb",
                            padding: "10px",
                            textAlign: "center",
                            fontWeight: "600",
                            color: "#374151",
                            minWidth: "120px",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "4px",
                            }}
                          >
                            <span
                              style={{ fontSize: "11px", color: "#6b7280" }}
                            >
                              {col.index || index + 1}
                            </span>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: col.text || "Empty",
                              }}
                            />
                          </div>
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {question.rows.map((row, rowIndex) => (
                      <tr
                        key={rowIndex}
                        style={{
                          backgroundColor:
                            rowIndex % 2 === 0 ? "white" : "#f9fafb",
                        }}
                      >
                        <td
                          style={{
                            border: "1px solid #e5e7eb",
                            padding: "10px",
                            fontWeight: "500",
                          }}
                        >
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: "6px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                              }}
                            >
                              <span
                                style={{
                                  fontSize: "11px",
                                  color: "#6b7280",
                                  fontWeight: "600",
                                }}
                              >
                                {row.index || rowIndex + 1}
                              </span>
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: row.text || "Empty",
                                }}
                              />
                            </div>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "4px",
                              }}
                            >
                              {row.screenout && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    backgroundColor: "#fee2e2",
                                    color: "#991b1b",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Screen Out
                                </span>
                              )}
                              {row.exclusive && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    backgroundColor: "#dbeafe",
                                    color: "#1e40af",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Exclusive
                                </span>
                              )}
                              {row.other && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    backgroundColor: "#fef3c7",
                                    color: "#92400e",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Other
                                </span>
                              )}
                              {row.fix && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    backgroundColor: "#e0e7ff",
                                    color: "#3730a3",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Fixed
                                </span>
                              )}
                              {row.filterLogic && (
                                <span
                                  style={{
                                    fontSize: "10px",
                                    padding: "2px 6px",
                                    backgroundColor: "#f3e8ff",
                                    color: "#6b21a8",
                                    borderRadius: "4px",
                                    fontWeight: "600",
                                  }}
                                >
                                  Logic: {row.filterLogic}
                                </span>
                              )}
                            </div>
                          </div>
                        </td>
                        {question.columns.map((col, colIndex) => (
                          <td
                            key={colIndex}
                            style={{
                              border: "1px solid #e5e7eb",
                              padding: "10px",
                              textAlign: "center",
                              color: "#6b7280",
                            }}
                          >
                            <div
                              style={{
                                width: "20px",
                                height: "20px",
                                border: "2px solid #d1d5db",
                                borderRadius: "4px",
                                margin: "0 auto",
                              }}
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          )}

        {/* Only Rows (no columns) */}
        {question.rows &&
          question.rows.length > 0 &&
          (!question.columns || question.columns.length === 0) && (
            <div className="preview-section">
              <label>Rows ({question.rows.length}):</label>
              <div className="preview-items-list">
                {question.rows.map((row, index) => (
                  <div key={index} className="preview-item">
                    <span className="item-index">{row.index || index + 1}</span>
                    <span
                      className="item-text"
                      dangerouslySetInnerHTML={{ __html: row.text || "Empty" }}
                    />
                    {row.screenout && (
                      <span className="item-flag screenout">Screen Out</span>
                    )}
                    {row.filterLogic && (
                      <span className="item-logic">
                        Logic: {row.filterLogic}
                      </span>
                    )}
                    {row.exclusive && (
                      <span className="item-flag exclusive">Exclusive</span>
                    )}
                    {row.other && (
                      <span className="item-flag other">Other</span>
                    )}
                    {row.fix && <span className="item-flag fix">Fixed</span>}
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Only Columns (no rows) */}
        {question.columns &&
          question.columns.length > 0 &&
          (!question.rows || question.rows.length === 0) && (
            <div className="preview-section">
              <label>Columns ({question.columns.length}):</label>
              <div className="preview-items-grid">
                {question.columns.map((col, index) => (
                  <div key={index} className="preview-grid-item">
                    <span className="item-index">{col.index || index + 1}</span>
                    <span
                      className="item-text"
                      dangerouslySetInnerHTML={{ __html: col.text || "Empty" }}
                    />
                  </div>
                ))}
              </div>
            </div>
          )}

        {/* Statements Preview */}
        {question.statements && question.statements.length > 0 && (
          <div className="preview-section">
            <label>Statements ({question.statements.length}):</label>
            <div className="preview-items-list">
              {question.statements.map((stmt, index) => (
                <div key={index} className="preview-item">
                  <span className="item-index">{stmt.index || index + 1}</span>
                  <span
                    className="item-text"
                    dangerouslySetInnerHTML={{ __html: stmt.text || "Empty" }}
                  />
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Settings Summary */}
        <div className="preview-section">
          <label>Settings:</label>
          <div className="preview-settings-list">
            {question.rowsRandomisation && (
              <span className="setting-badge">Rows Randomisation</span>
            )}
            {question.columnsRandomisation && (
              <span className="setting-badge">Columns Randomisation</span>
            )}
            {question.rowsRotation && (
              <span className="setting-badge">Rows Rotation</span>
            )}
            {question.columnsRotation && (
              <span className="setting-badge">Columns Rotation</span>
            )}
            {question.alphabeticalOrder && (
              <span className="setting-badge">Alphabetical Order</span>
            )}
            {question.columnIndex && (
              <span className="setting-badge">Column Index</span>
            )}
            {!question.rowsRandomisation &&
              !question.columnsRandomisation &&
              !question.rowsRotation &&
              !question.columnsRotation &&
              !question.alphabeticalOrder &&
              !question.columnIndex && (
                <span className="no-settings">No special settings</span>
              )}
          </div>
        </div>

        {/* OE Parameters */}
        {question.oeparameters &&
          Object.entries(question.oeparameters).filter(
            ([, value]) =>
              value !== false &&
              value !== null &&
              value !== undefined &&
              value !== ""
          ).length > 0 && (
            <div className="preview-section">
              <label>Open End Parameters:</label>
              <div className="preview-oe-params">
                {Object.entries(question.oeparameters)
                  .filter(
                    ([, value]) =>
                      value !== false &&
                      value !== null &&
                      value !== undefined &&
                      value !== ""
                  )
                  .map(([key, value]) => (
                    <div key={key} className="oe-param-item">
                      <span className="param-key">{key}:</span>
                      <span className="param-value">{String(value)}</span>
                    </div>
                  ))}
              </div>
            </div>
          )}
      </div>
    );
  };

  return (
    <>
      {/* Preview Button */}
      <CommonButton label="Quick Preview" title="Quick Preview of Current Question" onClick={() => setIsPreviewOpen(true)} />
      

      {/* Preview Modal */}
      <Modal
        isOpen={isPreviewOpen}
        onRequestClose={() => setIsPreviewOpen(false)}
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 10000,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
            width: "80%",
            height: "90vh",
            borderRadius: "12px",
            padding: "0",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column",
            boxSizing: "border-box",
          },
        }}
      >
        <div className="question-preview-modal">
          <div
            className="question-preview-header"
            style={{
              padding: "20px",
              borderBottom: "2px solid #e5e7eb",
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "white",
              position: "sticky",
              top: 0,
              zIndex: 1000,
            }}
          >
            <h2 style={{ margin: 0, color: "#374151", fontSize: "20px" }}>
              Preview: Q{questionNumber}
            </h2>
            <button
              onClick={() => setIsPreviewOpen(false)}
              style={{
                background: "none",
                border: "none",
                fontSize: "32px",
                cursor: "pointer",
                color: "#6b7280",
                lineHeight: "1",
                padding: "0",
                width: "32px",
                height: "32px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                transition: "color 0.2s ease",
              }}
              onMouseEnter={(e) => (e.target.style.color = "#374151")}
              onMouseLeave={(e) => (e.target.style.color = "#6b7280")}
            >
              ×
            </button>
          </div>

          <div
            style={{
              padding: "20px",
              overflowY: "auto",
              overflowX: "hidden",
              flex: 1,
            }}
          >
            {renderQuestionContent()}
          </div>
        </div>
      </Modal>
    </>
  );
};

export default QuestionPreview;
